import React from 'react';
import { MDBContainer, } from "mdb-react-ui-kit";
import "../css/servicesfont.css";
const techpreautho = () => {
    return (
        <MDBContainer fluid className="p-0">
            <div className="container py-5">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2">
                            <h1 className="title mb-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{ fontFamily: 'Lora, serif' }}>Patient Eligibility Verification</h1>
                            <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500',textAlign: 'justify' }}> 
                                Our <b>Patient Eligibility Verification </b>technology provides a user-friendly eligibility dashboard accessible to clients two days prior to a 
                                patient’s visit. This streamlined tool displays all essential details in one convenient screen for your front desk staff, including copay 
                                amounts, previous balances, insurance status, and authorization requirements for procedures. With just a click, your team can download previous
                                 balance statements without navigating multiple screens in the billing system. The integrated management reports help evaluate front desk 
                                 collection efficiency, supporting stronger <b>revenue cycle management, medical billing services,</b> and <b>medical billing outsourcing </b>performance. 
                                 Clients using our eligibility and verification services have seen up to a 150% increase in front desk collections, improving cash flow and 
                                 reducing administrative burden.</p>
                        </div>
                    </div>
                </div>
            </div>
        </MDBContainer>
    );
};
export default techpreautho;